import { bytesToUnit } from '@cast/utils';
import { ReactNode } from 'react';

import { NetworkAreaChart } from './_components/NetworkAreaChart';
import { useNetworkTrafficChartData } from './_hooks/useNetworkTrafficChartData';

const formatTrafficTick = (value: number) => {
  const [amount, unit] = bytesToUnit(value);
  return `${amount} ${unit}`;
};

const formatTrafficMetric = (
  value: number
): { value: number; unit: string } => {
  const [amount, unit] = bytesToUnit(value);
  return { value: amount, unit };
};

const formatTrafficTooltip = (value: number): ReactNode => {
  const [amount, unit] = bytesToUnit(value, 2);
  return `${amount} ${unit}`;
};

export const NetworkTrafficChart = () => {
  const { data, totals, isLoading, isFetching, error, refetch, timeZone } =
    useNetworkTrafficChartData();
  const isChartLoading = isLoading || (!!error && isFetching);

  return (
    <NetworkAreaChart
      title="Network traffic"
      testId="network-traffic-chart"
      data={data}
      totals={totals}
      timeZone={timeZone}
      unit="GiB"
      valueType="number"
      yAxisFormatter={formatTrafficTick}
      metricFormatter={formatTrafficMetric}
      tooltipFormatter={formatTrafficTooltip}
      isLoading={isChartLoading}
      error={error}
      refetch={refetch}
    />
  );
};
